module.exports = __webpack_public_path__ + "static/media/preview.ab578ad4.svg";